export type TBlogCtaLocation = 'top' | 'mid' | 'bottom';

export const trackBlogCtaClick = ({
  location,
  page,
}: {
  location: TBlogCtaLocation;
  page: string;
}) => {
  if (typeof window === 'undefined') return;

  window.gtag?.('event', 'blog_cta_click', {
    location,
    page,
  });
};
